import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../Context/LanguageContext";
import { FiAlertCircle, FiArrowLeft } from "react-icons/fi";

const BlogUnavailable = ({ backTo = "/blog" }) => {
  const { t } = useLanguage();
  return (
    <div className="blog-page">
      <div className="blog-page__inner">
        <div className="blog-empty blog-empty--stack mono">
          <p>
            <FiAlertCircle size={16} style={{ marginRight: 8 }} />
            {t("BlogNotConfigured")}
          </p>
          <p className="blog-empty__hint">{t("BlogHint")}</p>
          <Link to={backTo} className="blog-primary-btn">
            <FiArrowLeft size={14} /> {t("Back")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BlogUnavailable;
